module.exports = __webpack_public_path__ + "static/media/1-min.eb1c115b.jpg";